import "./yup-phone";
export const alphabetRegex = /^([A-Za-z]*)$/gi;
